import axios from "axios";
import { setDeliveryReportList,setUpdateOrderDetails,getCheckData,deliveryImportOrders,excelGenerateFile } from "../../../../Redux/delivery/deliverySlice";
import UserAuthKey from "../../../../components/Common/UserAuthKey";

const apiUrl = process.env.REACT_APP_OMS_API;
const bearerToken = UserAuthKey();
export const fetchDeliveryDataList = async({ params, dispatch }) => {
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/orders/get-delivery-schedule-orders`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  
  try {
    const response = await axios(config);
    dispatch(setDeliveryReportList(response?.data));
  } catch (error) {

  }
};


export const updateOrderStatus = async({ params, dispatch }) => {
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/orders/update-delivery-date`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);

    dispatch(setUpdateOrderDetails(response?.data));
  } catch (error) {

  }
};

export const fetchCheckData = async({ formData, dispatch }) => {
  const config = {
     method: 'POST',
     url: `${apiUrl}v1/orders/deliveryorder-checkData`,
     headers: {
      Authorization: `Bearer ${bearerToken}`,
     'Content-Type': "multipart/form-data",
    
      },
     
      data: formData, 
    
    };
  try {
     const response = await axios(config);
     dispatch(getCheckData(response?.data));
     } catch (error) {
  
    }
  // return axios
  // .post(`${apiUrl}v1/marketplace-orders/marketplaceorder-checkData`,formData,  {
  //   headers: {
  //     "Content-Type": "multipart/form-data",
  //   },
  // })
  // .then((response) => {
  //   dispatch(getCheckData(response?.data));
  // })
  // .catch((error) => {
  //   throw error;
  // });
    
};

export const fetchSprintCheckData = async({ formData, dispatch }) => {
  const config = {
     method: 'POST',
     url: `${apiUrl}v1/orders/sprint-checkData`,
     headers: {
      Authorization: `Bearer ${bearerToken}`,
     'Content-Type': "multipart/form-data",
    
      },
     
      data: formData, 
    
    };
  try {
     const response = await axios(config);
     dispatch(getCheckData(response?.data));
     } catch (error) {
  
    }
};

export const deliveryImportSummary = async({ params, dispatch }) => {
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/orders/deliveryorder-importData`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);
    dispatch(deliveryImportOrders(response?.data));

  } catch (error) {

  }

};

export const sprintImportSummary = async({ params, dispatch }) => {
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/orders/sprint-importData`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);
    dispatch(deliveryImportOrders(response?.data));

  } catch (error) {

  }

};

export const excelGenerate = async({ params, dispatch }) => {
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/orders/export_result`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);

    dispatch(excelGenerateFile(response?.data));
    window.location.href = response?.data?.data?.[0]?.report_link
  } catch (error) {
    console.log(error)
  }
};

export const sprintBulkAwbGenerate = async ({ lsReferences }) => {
  const trackingNos = (lsReferences || []).join(',');
  if (!trackingNos) {
    return { success: false, message: 'Please enter at least one ls_reference' };
  }

  try {
    const response = await axios({
      method: 'GET',
      url: `${apiUrl}v1/orders/sprint-label-printer?TrackingNos=${encodeURIComponent(trackingNos)}`,
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
      responseType: 'blob',
    });

    const contentType = response?.headers?.['content-type'] || '';
    if (contentType.includes('application/json')) {
      const text = await response.data.text();
      const json = JSON.parse(text || '{}');
      return {
        success: false,
        message: json?.message || 'Failed to generate Sprint AWB',
      };
    }

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const fileUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', `sprint_bulk_awb_${Date.now()}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(fileUrl);

    return { success: true, message: 'AWB downloaded successfully' };
  } catch (error) {
    let message = 'Failed to generate Sprint AWB';
    try {
      if (error?.response?.data) {
        const text = await error.response.data.text();
        const json = JSON.parse(text || '{}');
        message = json?.message || message;
      }
    } catch (e) {
    }
    return { success: false, message };
  }
};

export const marketplaceStockBigQueryInsert = async ({ formData }) => {
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/orders/hooks/bigquery/insert`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'multipart/form-data',
    },
    data: formData,
  };

  try {
    const response = await axios(config);
    return response?.data;
  } catch (error) {
    return error?.response?.data || { message: 'Failed to upload file' };
  }
};
